import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import href from '#utilities/js/ea/href.js'
import { get } from '#utilities/js/ea/ajax.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as generics from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import { close } from '#utilities/js/lightboxes/menus/dropdown.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

export const availability = async (
  form,
  rsrc,
  day,
  start,
  duration,
  type,
  target
) => {
  const url = href('calendar/req_cal_rsrc', {
    cal_rsrc: rsrc,
    day: day,
    start: start,
    duration: duration,
    availability: type
  })
  
  await get(url, { target: target })
}

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const { ownerDocument } = button
    const modal = one(`.${generics.elements.modal}`, ownerDocument)
    const opener = one(`.${utilities.modifiers.lightbox.open}`, modal)
    const { value } = button
    const form = closest('form', opener)
    const { value: day } = one('[type="hidden"][name="day"]', form)
    const { value: start } = one('[type="hidden"][name="start"]', form)
    const { value: duration } = one('[type="hidden"][name="duration"]', form)

    close()

    await availability(form, value, day, start, duration, 'rsrc', button)
  }
})

export default select => {
  onClick.listen(select)
}
